import TrashCan16 from '@carbon/icons-react/es/trash-can/16';
import { Col, Row, Typography } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Popconfirm } from 'components/atoms/popconfirm';

const GrayCol = styled(Col)`
  padding: var(--spacing-03) var(--spacing-05);
  background-color: var(--gray-10);
  height: 38px;
`;

export const DeleteButton = styled(Button).attrs({ type: 'link' })`
  color: var(--gray-50);
  height: auto;
  &:hover,
  &:focus {
    color: var(--red-60);
  }
`;

const { Text } = Typography;

export const Header = ({
  name,
  onRemove,
}: {
  name: string;
  onRemove: () => void;
}) => (
  <Row gutter={[0, 0]}>
    <GrayCol flex="412px">
      <Text strong> {name}</Text>
    </GrayCol>
    <GrayCol flex="412px">
      <Text strong>
        <FormattedMessage id="project" />
      </Text>
    </GrayCol>
    <GrayCol flex="auto">
      <Popconfirm
        onConfirm={onRemove}
        subTitle={
          <FormattedMessage id="settings.integrations.sf.resource_mappings.delete" />
        }
      >
        <DeleteButton size="small" icon={<TrashCan16 />} />
      </Popconfirm>
    </GrayCol>
    <GrayCol flex="auto" />
  </Row>
);
